import React from 'react';
import PropTypes from 'prop-types';

import styles from '../SignUp.module.scss';
import { Form, Input } from '@solarwindscloud/cloud-ui';
import { isPasswordValid } from '@solarwindscloud/swicus-validation';
import { passwordRestrictionsMessage } from '../../../utils/utils';

export const PasswordInput = ({ handleChange, handleError, value, hasError, name }) => {
  return (
    <Form.Field className={styles.field} error={hasError}>
      <Input
        type="password"
        error={hasError}
        className={styles.input}
        name={name}
        placeholder="Password"
        icon="locked"
        iconPosition="left"
        value={value}
        onChange={(event, data) => handleChange(data.value)}
        onBlur={validatePassword}
      />
    </Form.Field>
  );

  function validatePassword() {
    if (!isPasswordValid(value)) {
      handleError(passwordRestrictionsMessage);
    }
  }
};

PasswordInput.displayName = 'PasswordInput';
PasswordInput.propTypes = {
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleError: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
};
